import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListItem } from '@models/models';

@Component({
	selector: 'template-apply-list',
	template: require('./template-apply-list.component.html'),
	styles: [require('./template-apply-list.component.scss')]
})
export class TemplateApplyListComponent {
	@Input() text: string;
	@Input() idField = 'id';
	@Input() defaultOptionName = 'None';
	@Input() templateList: Array<ListItem>;
	@Input() disabled: boolean;
	@Input() selectedTemplateId: string;
	@Input() disablePlaceholder: boolean;
	@Output() onTemplateChange: EventEmitter<string> = new EventEmitter();

	onChange(event): void {
		this.onTemplateChange.emit(event);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/common/payment-schedule-template-list/template-apply-list.component.ts